import type { ElementType, HTMLAttributes } from 'react';
import clsx from 'clsx';

type Props = HTMLAttributes<HTMLElement> & { as?: ElementType };

// The design's container is 1200px of CONTENT plus the gutter on each side
// (it uses content-box). Tailwind is border-box, so the gutter is added back
// to the max-width: the content is exactly 1200px wide at 1440 and up.
export function Container({ as: Tag = 'div', className, ...rest }: Props) {
  return (
    <Tag
      className={clsx(
        'mx-auto w-full max-w-[calc(var(--container-site)+2*var(--spacing-gutter))] px-gutter',
        className,
      )}
      {...rest}
    />
  );
}
